import { render, staticRenderFns } from "./accountProduct.vue?vue&type=template&id=e6568cf0&"
import script from "./accountProduct.vue?vue&type=script&lang=js&"
export * from "./accountProduct.vue?vue&type=script&lang=js&"
import style0 from "./accountProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports